import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type Props = {};

const SiteBuildCustomComponent = (props: Props) => {
  const { t } = useTranslation();

  return (
    <section id="build-custom" className="bg-eighteenColor px-1">
      <Container>
        <Row className="p-2 p-lg-5">
          <Col className="px-lg-5">
            <Row className="px-lg-5 md:tw-my-20">
              <Col lg="6" md="6" sm={{ order: "last" }} className="pt-5">
                <Row className="px-lg-5">
                  <Col>
                    <Row>
                      <Col className="p-0">
                        <h1 className="font-sofiaSans fw-bolder">
                          {t("home/SiteBuildCustom/title-01")}
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="p-0">
                        <p className="fs-3 font-sofiaSans">
                          {t("home/SiteBuildCustom/text-01")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg="6" md="6" sm={{ order: "first" }} className="p-0">
                <Row className="px-lg-5">
                  <Col>
                    <img
                      loading="lazy"
                      crossOrigin="anonymous"
                      src={
                        "https://cdn.1cdn.app/application/LOUISEBOT/23082613390626_1.png"
                      }
                      className="h-100 w-100"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="px-lg-5 md:tw-my-20">
              <Col lg="6" md="6" className="pt-5">
                <Row className="px-lg-5">
                  <Col>
                    <Row>
                      <Col className="p-0">
                        <h1 className="font-sofiaSans fw-bold">
                          {t("home/SiteBuildCustom/title-02")}
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="p-0">
                        <p className="fs-3 font-sofiaSans">
                          {t("home/SiteBuildCustom/text-02")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg="6" md="6">
                <Row className="px-lg-5">
                  <Col>
                    <img
                      loading="lazy"
                      crossOrigin="anonymous"
                      src={
                        "https://cdn.1cdn.app/application/LOUISEBOT/23082613390662_2.png"
                      }
                      className="h-100 w-100"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="px-lg-5 md:tw-my-20">
              <Col lg="6" md="6" sm={{ order: "last" }} className="pt-5">
                <Row className="px-lg-5">
                  <Col>
                    <Row>
                      <Col className="p-0">
                        <h1 className="font-sofiaSans fw-bold">
                          {t("home/SiteBuildCustom/text-03")}
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="p-0">
                        <p className="fs-3 font-sofiaSans">
                          {t("home/SiteBuildCustom/text-04")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg="6" md="6" sm={{ order: "first" }} className="p-0">
                <Row className="px-lg-5">
                  <Col>
                    <img
                      loading="lazy"
                      crossOrigin="anonymous"
                      src={
                        "https://cdn.1cdn.app/application/LOUISEBOT/23092708594754_Landing.png"
                      }
                      className="h-100 w-100 "
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="px-lg-5 md:tw-my-20">
              <Col lg="6" md="6" className="pt-5">
                <Row className="px-lg-5">
                  <Col>
                    <Row>
                      <Col className="p-0">
                        <h1 className="font-sofiaSans fw-bold">
                          {t("home/SiteBuildCustom/title-03")}
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="p-0">
                        <p className="fs-3 font-sofiaSans">
                          {t("home/SiteBuildCustom/text-05")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg="6" md="6">
                <Row className="px-lg-5">
                  <Col className="p-0">
                    <img
                      loading="lazy"
                      crossOrigin="anonymous"
                      src={
                        "https://cdn.1cdn.app/application/LOUISEBOT/23082613390634_4.png"
                      }
                      className="h-100 w-100"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteBuildCustomComponent;
